/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize Psychosocial Risk Psycology View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './PsychosocialRiskPsycologyView';

export const mapStateToPropsPsychosocialRiskPsycology = mapStateToProps;
export const mapDispatchToPropsPsychosocialRiskPsycology = mapDispatchToProps;

export default connect(
  mapStateToPropsPsychosocialRiskPsycology,
  mapDispatchToPropsPsychosocialRiskPsycology
)(View);
